import * as videojs from 'video.js'

export function videoPlayer(elements?: NodeListOf<HTMLVideoElement>) {
  let videos: NodeListOf<HTMLVideoElement>;

  if (elements) {
    videos = elements;
  } else {
    videos = document.querySelectorAll(
      '.video-js'
    )
  }

  if (!videos.length) {
    return;
  }

  videos.forEach((videoPlayer) => {
    videojs(videoPlayer, {
      fluid: true,
    })
  })
}
